import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableBalanceHistory = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableBalanceHistory);
};
